import React from 'react';
import './PC.css';
import Gosebrink from '../../img/pc/Gosebrink.png'
import Gosebrink1 from '../../img/pc/Gosebrink-1.jpg'
import Kaufman from '../../img/pc/Kaufman.png'
import Kaufman1 from '../../img/pc/Kaufman-1.jpg'
import Kuncevic from '../../img/pc/Kuncevic.png'
import Kuncevic1 from '../../img/pc/Kuncevic-1.jpg'
import Salnikov from '../../img/pc/Salnikov.png'
import Salnikov1 from '../../img/pc/Salnikov-1.jpg'
import AngularRocks from '../../img/pc/AngularRocks.png'
import Microsoft from '../../img/pc/Microsoft.png'
import NextInsurance from '../../img/pc/NextInsurance.png'
import OfferingSolutionsSoftware from '../../img/pc/OfferingSolutionsSoftware.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Salnikov,
          photo1: Salnikov1,
          name: 'Maxim Salnikov',
          position: 'Senior Developer Engagement Lead',
          tw: 'https://twitter.com/webmaxru',
          logo: Microsoft,
        },
        {
          photo: Kaufman,
          photo1: Kaufman1,
          name: 'Nir Kaufman',
          position: 'Frontend Tech Lead',
          website: 'https://nir.life',
          logo: NextInsurance,
        },
        {
          photo: Kuncevic,
          photo1: Kuncevic1,
          name: 'Aliaksei Kuncevic',
          position: 'Google Developer Expert',
          tw: 'https://twitter.com/@kuncevic',
          logo: AngularRocks,
        },
        {
          photo: Gosebrink,
          photo1: Gosebrink1,
          name: 'Fabian Gosebrink',
          position: 'Technical Lead',
          tw: 'https://twitter.com/fabiangosebrink',
          logo: OfferingSolutionsSoftware,
        },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo1}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pcc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program <span className='title_gradient'>committee</span></h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}